"use client"

import ContactForm from "components/ContactForm"
import { css, f, styled } from "library/styled"
import { useRef } from "react"
import colors from "styles/colors"

export default function ContactSection({
	fullPage = false,
}: {
	fullPage?: boolean
}) {
	const wrapperRef = useRef<HTMLDivElement | null>(null)

	return (
		<Wrapper ref={wrapperRef} fullPage={fullPage}>
			<Inner>
				<ContactForm
					fullPage={fullPage}
					onComplete={() => {
						console.info("Form submission attempted")
					}}
				/>
			</Inner>
		</Wrapper>
	)
}

const Wrapper = styled("div", ({ fullPage }: { fullPage?: boolean }) => ({
	...f.responsive(css`
		position: relative;
		width: 100%;
		background-color: ${colors.offWhite};
		overflow: clip;
		min-height: ${fullPage ? "100vh" : "auto"};
	`),
}))

const Inner = styled("div", {
	...f.responsive(css`
		position: relative;
		width: 1440px;
		user-select: none;
		padding: 108px 90px;
		margin: 0 auto;
	`),
	...f.tablet(css`
		width: 1024px;
		padding: 96px 32px;
	`),
	...f.mobile(css`
		width: 375px;
		padding: 24px;
	`),
})
